import React from 'react'

interface MaterialIconProps {
  icon: string
  style?: React.CSSProperties
  className?: string
  filled?: boolean
}

const MaterialIcon: React.FC<MaterialIconProps> = ({ 
  icon, 
  style = {}, 
  className = '',
  filled = false 
}) => {
  const iconClass = filled ? 'material-icons' : 'material-symbols-outlined'
  
  return (
    <span 
      className={`${iconClass} ${className}`}
      style={{ 
        verticalAlign: 'middle',
        fontSize: '20px',
        ...style 
      }}
    >
      {icon}
    </span>
  )
}

export default MaterialIcon

